import { ReactNode } from 'react';
import { View } from 'react-native-animatable';

type Props = {
  leftGrid: ReactNode;
  rightGrid: ReactNode;
};

export const SelectLayout = ({ leftGrid, rightGrid }: Props) => {
  return (
    <View className="flex-1 flex-row">
      <View className="flex-[3]">{leftGrid}</View>
      <View className="flex-[1] justify-around items-center">{rightGrid}</View>
    </View>
  );
};
